/**
 * @module router/audit
 * @description Rutas del módulo de auditoría
 */
export default [
  {
    path: "/audit",
    component: () =>
      import(
        /* webpackChunkName: "audit" */ "@/components/audit/AuditLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "audit-list",
        component: () =>
          import(
            /* webpackChunkName: "audit" */ "@/components/audit/AuditList.vue"
          ),
      },
      {
        path: ":id",
        name: "audit-detail",
        component: () =>
          import(
            /* webpackChunkName: "audit" */ "@/components/audit/AuditDetail.vue"
          ),
      },
    ],
  },
];
